import { validateId } from '~/repositories/utils';
import { BaseRestRepository } from './baseRestRepository';

const DEBUG_URL = '/api/debug';

export type PlaidFailed = {
  failureCode: string;
  description: string;
};

export class DebugRepository extends BaseRestRepository {
  public async setPlaidStatusSettled(plaidId: string) {
    validateId(plaidId);

    const url = `${DEBUG_URL}/plaid/transfers/${plaidId}/settled`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(plaidId),
    });
    return this.getJsonResponse(response);
  }

  public async setPlaidStatusFailed(plaidId: string, payload: PlaidFailed) {
    validateId(plaidId);

    const url = `${DEBUG_URL}/plaid/transfers/${plaidId}/failed`;
    await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  public async setPlaidStatusReturned(plaidId: string) {
    validateId(plaidId);

    const url = `${DEBUG_URL}/plaid/transfers/${plaidId}/returned`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(plaidId),
    });
    return this.getJsonResponse(response);
  }

  public async setStripeStatusSettled(bankAccountId: string) {
    validateId(bankAccountId);

    const url = `${DEBUG_URL}/stripe/connect/${bankAccountId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
    });
    return this.getJsonResponse(response);
  }
}

export const debugRepository = new DebugRepository();
